var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#731982"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_2226)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1252 17.375H8.87499C8.53007 17.375 8.25024 17.655 8.25024 18C8.25024 18.345 8.53007 18.625 8.87499 18.625H20.1252C20.4701 18.625 20.75 18.345 20.75 18C20.75 17.655 20.4701 17.375 20.1252 17.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2412 18L16.5581 15.3169C16.314 15.0731 16.314 14.6769 16.5581 14.4331C16.8018 14.1891 17.1981 14.1891 17.4418 14.4331L20.5668 17.5581C20.8109 17.8022 20.8109 18.1978 20.5668 18.4419L17.4418 21.5669C17.1981 21.8109 16.8018 21.8109 16.5581 21.5669C16.314 21.3231 16.314 20.9269 16.5581 20.6831L19.2412 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 20.5V21.125C10.75 23.5397 12.7103 25.5 15.125 25.5H21.375C23.7897 25.5 25.75 23.5397 25.75 21.125V14.875C25.75 12.4603 23.7897 10.5 21.375 10.5H15.125C12.7103 10.5 10.75 12.4603 10.75 14.875V18C10.75 18.345 11.03 18.625 11.375 18.625C11.72 18.625 12 18.345 12 18V14.875C12 13.1503 13.4003 11.75 15.125 11.75H21.375C23.0997 11.75 24.5 13.1503 24.5 14.875V21.125C24.5 22.8497 23.0997 24.25 21.375 24.25H15.125C13.4003 24.25 12 22.8497 12 21.125V20.5C12 20.155 11.72 19.875 11.375 19.875C11.03 19.875 10.75 20.155 10.75 20.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_2226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(7 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.d70c6b05d7f7ab02d288ea87b1bdc54d.svg";
export { ForwardRef as ReactComponent };